import React from "react";
import { DateTimeDisplay } from "../../views";
import styles from "./ShowCounter.module.scss";
import { ShowCounterTypes } from "./types";

const ShowCounter: React.FC<ShowCounterTypes> = ({ seconds }) => {
  return (
    <div className={styles.show__counter}>
      <DateTimeDisplay value={seconds} type={"Seconds"} isDanger={false} />
    </div>
  );
};

export default ShowCounter;
